var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNavyBlueColorLine = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 2,
  viewBox: "0 0 32 2",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 0.531983,
  y1: 1,
  x2: 31.532,
  y2: 1,
  stroke: "#5194B1",
  strokeWidth: 2
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgNavyBlueColorLine);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/navy-blue-color-line.23fbe152cafb122beb176924dc040f54.svg";